<div class="flex h-full min-h-0 flex-col gap-4 overflow-hidden">
    <div class="flex flex-wrap items-end justify-between gap-3">
        <div>
            <h2 class="text-2xl font-bold tracking-tight text-primary">Posts found</h2>
            <p class="mt-1 max-w-prose text-sm text-secondary">Posts from the creators on this brief, including Stories.</p>
        </div>
        <div class="grid grid-cols-1">
            <input [formField]="searchQueryForm.query" id="brief-search" type="text" placeholder="Search posts"
                aria-label="Search posts" class="input-icon text-primary" />
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="pointer-events-none col-start-1 row-start-1 ml-3 size-4 self-center text-secondary"
                aria-hidden="true">
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
            </svg>
        </div>
    </div>

    @if (status(); as current) {
    @if (current.kind === 'loading') {
    <p class="rounded-xl border border-border bg-card p-8 text-center text-sm text-secondary" aria-busy="true">
        {{ current.label }}
    </p>
    } @else if (current.kind === 'empty') {
    <div class="rounded-xl border border-dashed border-border p-10 text-center">
        <h3 class="text-sm font-semibold text-primary">{{ current.title }}</h3>
        <p class="mt-1 text-sm text-secondary">{{ current.body }}</p>
    </div>
    } @else if (current.kind === 'no-match') {
    <div class="rounded-xl border border-dashed border-border p-10 text-center">
        <h3 class="text-sm font-semibold text-primary">{{ current.title }}</h3>
        <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary mt-3" (click)="clearSearch()">
            Clear search
        </button>
    </div>
    } @else {
    <div class="-mx-1 min-h-0 flex-1 overflow-y-auto px-1 pb-4 scrollbar-transparent" #scrollContainer infinite-scroll
        [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100" [infiniteScrollContainer]="scrollContainer"
        [infiniteScrollDisabled]="!hasMore() || isLoadingMore()" (scrolled)="onScrollDown()">
        <ul role="list" class="content-grid grid content-start gap-4">
            @for (content of publishedContent()!; track content.id) {
            <li class="flex min-w-0 flex-col overflow-hidden rounded-xl border border-border bg-card shadow-sm">
                <div class="media-frame relative aspect-9/16 w-full shrink-0 overflow-hidden">
                    <div class="absolute top-2 right-2 z-20">
                        <div class="social-plt-badge text-secondary">
                            @if (content.socialPlatform == 'TikTok') {
                            <img class="mx-auto size-4" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                                alt="TikTok">
                            } @else if (content.socialPlatform == 'Instagram') {
                            <img class="mx-auto size-4" src="../../../../../assets/social-icon/instagram-logo.png"
                                alt="Instagram">
                            } @else {
                            <p class="text-xs text-white">Post</p>
                            }
                        </div>
                    </div>
                    @if (content.video) {
                    <div class="absolute inset-0 flex items-center">
                        <mb-atom-video-preview class="block w-full" [video]="content.video"></mb-atom-video-preview>
                    </div>
                    } @else {
                    <div class="absolute inset-0">
                        <mb-atom-carousel-preview class="block h-full w-full"
                            [images]="content.images"></mb-atom-carousel-preview>
                    </div>
                    }
                </div>
                <div class="flex w-full items-center gap-2.5 p-3">
                    @if (content.creator && content.creator.photoURL) {
                    <img [src]="imageService.getImageSource(content.creator.photoURL, 'gallery')" alt=""
                        class="size-8 shrink-0 rounded-full bg-gray-300 object-cover" />
                    } @else {
                    <img [src]="imageService.getImageSource(placeholderImage(), 'gallery')" alt=""
                        class="size-8 shrink-0 rounded-full bg-gray-300 object-cover" />
                    }
                    <div class="min-w-0 flex-1 text-start">
                        <h3 class="truncate text-sm font-medium text-primary">{{ getHandle(content) }}</h3>
                        <p class="truncate text-xs text-secondary">
                            @if (content.creator) {
                            {{ content.creator.firstName }} {{ content.creator.lastName.charAt(0) }}. ·
                            }
                            {{ formatService.getTimeSinceUpdated(content.timestamp) }}
                        </p>
                    </div>
                </div>
            </li>
            }
        </ul>
        @if (isLoadingMore()) {
        <p class="py-4 text-center text-sm text-secondary" aria-live="polite">Loading posts…</p>
        }
    </div>
    }
    }
</div>
